import type { Theme } from "@mui/material";
import { Box, DialogContent, DialogTitle, Stack, useMediaQuery } from "@mui/material";
import PoweredBy from "../PoweredBy";
import HtmlPreview from "../html/HtmlPreview";
import ConsentAgreementClientTitle from "./ConsentAgreementClientTitle";
import ConsentAgreementDefaultContent from "./ConsentAgreementDefaultContent";

interface ConsentDialogBodyProps {
  clientTitle?: string;
  logoUrl?: string;
  consentContent?: string;
  saveButton: React.ReactNode;
  acceptFormGroup: React.ReactNode;
  showTitle?: boolean;
  title: string;
}

const ConsentDialogBody = ({
  saveButton,
  acceptFormGroup,
  logoUrl,
  clientTitle,
  consentContent,
  showTitle,
  title,
}: ConsentDialogBodyProps) => {
  const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  return (
    <>
      <DialogTitle>
        <ConsentAgreementClientTitle logoUrl={logoUrl} clientTitle={clientTitle} showTitle={showTitle} />
      </DialogTitle>
      <DialogContent dividers={consentContent !== undefined}>
        <Box sx={[{ px: 1 }, (theme) => ({ [theme.breakpoints.up("md")]: { minWidth: "27rem" } })]}>
          {consentContent === undefined ? (
            <ConsentAgreementDefaultContent title={title} />
          ) : (
            <HtmlPreview htmlContent={consentContent} />
          )}
        </Box>
      </DialogContent>
      <Stack spacing={1} sx={{ px: 3, pb: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
            flexDirection: isSmallScreen ? "column" : "row",
          }}
        >
          {acceptFormGroup}
          {saveButton}
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <PoweredBy />
        </Box>
      </Stack>
    </>
  );
};

export default ConsentDialogBody;
